export default __webpack_public_path__ + "static/media/safety2.5825c307.png";